import { FreimaurerEntry } from '../model/freimaurer';
import { DataFetcher } from './fetcher/DataFetcher/index.ts';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface FreimaurerSearchParams
  extends Omit<Partial<FreimaurerEntry>, 'related_persons_names'>, AbstractSearchParams {
  year?: number;
  category?: string;
  related_persons_names?: string;
  typ?: string;
  continent?: string;
  country?: string;
}

export class FreimaurerRepository extends RepositoryNocoDbBase<FreimaurerEntry, FreimaurerSearchParams> {
  protected readonly TABLE_NAME = 'freimaurer';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly DATE_FIELD: 'CreatedAt';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS = ['continents', 'year', 'category', 'related_persons_names', 'typ', 'country'];
  protected readonly SEARCH_FIELDS: (keyof FreimaurerEntry)[] = [
    'name',
    'essence_of_research',
    'headline',
    'freemasonry_person',
    'category'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
